
import * as React from 'react';
import PropTypes from 'prop-types';
import SelectableChip from '../infrastructure/chips/SelectableChip'
import LanguageIcon from '@mui/icons-material/Language'

const JurisdictionChip = ({ id, label, selected, disabled, onClick }) =>(
    <SelectableChip
        id={id}
        icon={<LanguageIcon />}
        label={label}
        selected={selected}
        disabled={disabled}
        onClick={onClick}
    />
);

JurisdictionChip.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string.isRequired,
    selected: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func
};

JurisdictionChip.defaultProps = {
    selected: false,
    onClick: null
}
export default JurisdictionChip;